/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

// Functions helpers
const Functions = require('./files/functions.js');
Functions.spollers();
Functions.phoneMask();
Functions.selectOptions();
Functions.recordPersonalTraining();

// React Components
require('./components/Map')
require('./components/ContactForm')
require('./components/LanguageSwitcher')
require('./components/PopupContact')
require('./components/MobileNav')
require('./components/LoadMoreBlog')
require('./components/ScrollTop')
require('./components/CollapseBtn')
require('./components/SingleRegistration');
require('./components/AdvantagesSlider');
require('./components/TrainerSlider');
require('./components/CreateOrderPopup');
